export var ContentObjectType;
(function (ContentObjectType) {
    ContentObjectType["Dashboard"] = "DASHBOARD";
    ContentObjectType["FieldFormat"] = "FIELD_FORMAT";
    ContentObjectType["SecurityRule"] = "SECURITY_RULE";
})(ContentObjectType || (ContentObjectType = {}));
export var SavedObjectType;
(function (SavedObjectType) {
    SavedObjectType["None"] = "none";
    SavedObjectType["Search"] = "search";
    SavedObjectType["Visualization"] = "visualization";
    SavedObjectType["Dashboard"] = "dashboard";
    SavedObjectType["FieldFormat"] = "fieldFormat";
    SavedObjectType["Url"] = "url";
    SavedObjectType["Query"] = "query";
})(SavedObjectType || (SavedObjectType = {}));
export var ContentObjectStatus;
(function (ContentObjectStatus) {
    ContentObjectStatus["Submitted"] = "SUBMITTED";
    ContentObjectStatus["Approved"] = "APPROVED";
    ContentObjectStatus["Rejected"] = "REJECTED";
})(ContentObjectStatus || (ContentObjectStatus = {}));
//# sourceMappingURL=content-object-type.enum.js.map